import { render, staticRenderFns } from "./TenantViewSidebarAdd.vue?vue&type=template&id=752d89d6&scoped=true&"
import script from "./TenantViewSidebarAdd.vue?vue&type=script&lang=js&"
export * from "./TenantViewSidebarAdd.vue?vue&type=script&lang=js&"
import style0 from "./TenantViewSidebarAdd.vue?vue&type=style&index=0&id=752d89d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752d89d6",
  null
  
)

export default component.exports